import graphql from "graphql-tag"

import { MONEY_FRAGMENT } from "./moneyFragment"
import { VARIANT_WITH_PRODUCT_FRAGMENT } from "./variantWithProductFragment"

export const CART_FRAGMENT = graphql`
  fragment CartFragment on Cart {
    appliedGiftCards {
      amountUsed {
        ...MoneyFragment
      }
    }
    attributes {
      key
      value
    }
    buyerIdentity {
      countryCode
    }
    checkoutUrl
    cost {
      subtotalAmount {
        ...MoneyFragment
      }
      totalAmount {
        ...MoneyFragment
      }
      totalTaxAmount {
        ...MoneyFragment
      }
    }
    createdAt
    discountAllocations {
      discountedAmount {
        ...MoneyFragment
      }
    }
    discountCodes {
      applicable
      code
    }
    id
    lines(first: 250) {
      edges {
        node {
          discountAllocations {
            ... on CartCustomDiscountAllocation {
              __typename
              title
              discountedAmount {
                amount
                currencyCode
              }
            }
            ... on CartAutomaticDiscountAllocation {
              __typename
              title
              discountedAmount {
                amount
                currencyCode
              }
            }
            discountedAmount {
              ...MoneyFragment
            }
          }
          attributes {
            key
            value
          }
          cost {
            amountPerQuantity {
              ...MoneyFragment
            }
            compareAtAmountPerQuantity {
              ...MoneyFragment
            }
            subtotalAmount {
              ...MoneyFragment
            }
            totalAmount {
              ...MoneyFragment
            }
          }
          id
          merchandise {
            ...VariantWithProductFragment
          }
          quantity
        }
      }
    }
    note
    totalQuantity
    updatedAt
  }
  ${MONEY_FRAGMENT}
  ${VARIANT_WITH_PRODUCT_FRAGMENT}
`
